import React, { Component } from 'react';
import Holidays from '../../containers/employees/holidays/index'
import Attendance from '../../containers/employees/attendance/index'
import Leave from '../../containers/employees/leave/index'
import TaxSaving from '../../containers/employees/taxSavings/index'
import TaxSaving2 from '../../containers/employees/taxSavings2/index'
import LeaveReport from '../../containers/admin/leaveReport/index'
import AppConfig from '../../appConfig';
import { Route, NavLink } from 'react-router-dom'
import { connect } from 'react-redux';
import { getUserId } from '../../common/utils';

class Index extends Component {

    render() {
        const userId = getUserId();
        return (
            <div>
                <div className="secondary-navbar">
                    <span><NavLink exact to={AppConfig.baseUrl + 'Employees'} className={"nav-link"}>ATTENDANCE</NavLink></span>
                    <span><NavLink to={AppConfig.baseUrl + 'Employees/Leaves'} className={"nav-link"} >LEAVES</NavLink></span>
                    <span><NavLink to={AppConfig.baseUrl + 'Employees/LeaveReport'} className={"nav-link"} >LEAVE REPORT</NavLink></span>
                    <span><NavLink to={AppConfig.baseUrl + 'Employees/Holidays'} className={"nav-link"} >HOLIDAYS</NavLink></span>
                    <span><NavLink to={AppConfig.baseUrl + 'Employees/TaxSavings'} className={"nav-link"} >TAX SAVINGS</NavLink></span>
                    <span><NavLink to={AppConfig.baseUrl + 'Employees/TaxSavings2'} className={"nav-link"} >TAX SAVINGS2</NavLink></span>
                </div>
                <div>
                    <Route path={AppConfig.baseUrl + 'Employees'} exact strict render={() => { return (<Attendance employeeData={this.props.employeeData} dashboardData={this.props.dashboardData} />) }} />
                    <Route path={AppConfig.baseUrl + 'Employees/Leaves'} exact strict render={() => { return (<Leave employeeData={this.props.employeeData} dashboardData={this.props.dashboardData} />) }} />
                    <Route path={AppConfig.baseUrl + 'Employees/LeaveReport'} exact strict render={() => { return (<LeaveReport employeeData={this.props.employeeData} dashboardData={this.props.dashboardData} leaveUser={'employee'} />) }} />
                    <Route path={AppConfig.baseUrl + 'Employees/Holidays'} exact strict render={() => { return (<Holidays employeeData={this.props.employeeData} dashboardData={this.props.dashboardData} />) }} />
                    <Route path={AppConfig.baseUrl + 'Employees/TaxSavings'} exact strict render={() => { return (<TaxSaving employeeData={this.props.employeeData} dashboardData={this.props.dashboardData} />) }} />
                    <Route path={AppConfig.baseUrl + 'Employees/TaxSavings2'} exact strict render={() => { return (<TaxSaving2 userId={userId} employeeData={this.props.employeeData} dashboardData={this.props.dashboardData} />) }} />

                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        employeeData: state.employeeData,
        dashboardData: state.dashboardData,
    }
}
export default connect(mapStateToProps)(Index)

